export type Phase = 'dev' | 'prod';

const getPhase = (): Phase => {
  return process.env.NEXT_PUBLIC_PHASE === 'prod' ? 'prod' : 'dev';
};

export const PHASE = getPhase();
